// @ts-nocheck

import {
  GetStudiesRequest,
  StudyRef,
  StudyDetail,
  StudyCreate,
  StudyUpdate,
} from '@/types/studies';
import { api } from './index';

class StudiesService {
  // --------------------------------------- V3 - VERSION 3 ------------------------------------------

  /**
   * Get all studies with filtering (V3)
   * GET /v3/studies/
   * NEW IN V3 ✅
   */
  async getAllStudies(params?: GetStudiesParams): Promise<PaginatedStudiesResponse> {
    try {
      const response = await api.get<PaginatedStudiesResponse>('/studies/', { params });
      // If API doesn't return pagination format, adapt it
      if (Array.isArray(response.data)) {
        return {
          data: response.data,
          total: response.data.length,
          offset: params?.offset || 0,
        };
      }
      return response.data;
    } catch (error) {
      console.error('Error fetching studies (V3):', error);
      throw error;
    }
  }

  /**
   * Create a new study (V3)
   * POST /v3/studies/
   * NEW IN V3 ✅
   */
  async createStudy(studyData: StudyCreate): Promise<StudyDetail> {
    try {
      const response = await api.post<StudyDetail>('/studies/', studyData);
      return response.data;
    } catch (error) {
      console.error('Error creating study (V3):', error);
      throw error;
    }
  }

  /**
   * Get study by ID (V3)
   * GET /v3/studies/{study_id}
   * NEW IN V3 ✅
   */
  async getStudyProfile(studyId: string): Promise<StudyDetail> {
    try {
      const response = await api.get<StudyDetail>(`/studies/${studyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching study profile for ${studyId} (V3):`, error);
      throw error;
    }
  }

  /**
   * Update study (V3)
   * PATCH /v3/studies/{study_id}
   * NEW IN V3 ✅
   */
  async updateStudy(studyId: string, data: StudyUpdate): Promise<StudyDetail> {
    try {
      const response = await api.patch<StudyDetail>(`/studies/${studyId}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating study ${studyId} (V3):`, error);
      throw error;
    }
  }

  /**
   * Delete study (V3)
   * DELETE /v3/studies/{study_id}
   * NEW IN V3 ✅
   */
  async deleteStudy(studyId: string): Promise<void> {
    try {
      await api.delete(`/studies/${studyId}`);
    } catch (error) {
      console.error(`Error deleting study ${studyId} (V3):`, error);
      throw error;
    }
  }
}

export const studiesService = new StudiesService();
